import { useTranslation } from "react-i18next";
import { AppDropdown } from "@/shared/Components/AppDropdown";
import { DotsIcon } from "@/shared/icons";
import type { NotesListCardData, NotesListCardProps } from "../../model";
import type { FC } from "react";
import type { MenuProps } from "antd";

type Props = {
  cardData: NotesListCardData;
  onStatusChange: NotesListCardProps["onStatusChange"];
};

export const StatusMenuDropdown: FC<Props> = ({ onStatusChange, cardData }) => {
  const { t } = useTranslation();

  const menuItems: MenuProps["items"] = [
    { label: t("common.status.toDo"), key: "1", onClick: () => onStatusChange(cardData, "TO_DO") },
    {
      label: t("common.status.inProgress"),
      key: "2",
      onClick: () => onStatusChange(cardData, "IN_PROGRESS"),
    },
    { label: t("common.status.done"), key: "3", onClick: () => onStatusChange(cardData, "DONE") },
  ];

  return (
    <AppDropdown trigger={["click"]} menu={{ items: menuItems }}>
      <DotsIcon />
    </AppDropdown>
  );
};
